import { internetStatus } from '@/utils/constants';
import { bizmatesApi } from '@/utils/bizmatesApi';

export default {
  namespaced: true,
  state: {
    canReconnect: true,
    connectionProblem: false,
    internetStatus: true,
    internetFailCount: 0,
    refreshed: false
  },
  mutations: {
    setCanReconnect(state, payload) {
      state.canReconnect = payload;
    },
    setConnectionProblem(state, payload) {
      state.connectionProblem = payload
    },
    setInternetStatus(state, payload) {
      state.internetStatus = payload.type === internetStatus.online;
    },
    setInternetFailCount(state, payload) {
      state.internetFailCount = !payload ? 0 : state.internetFailCount + payload;
      state.internetStatus = !state.internetFailCount;
    },
    setRefreshed(state, payload) {
      state.refreshed = payload;
    }
  },
  actions: {
     /**
     * Action to update connection problem to true
     *
     * @param {commit} commit
     * @return void
     */
    hasConnectionProblem ({ commit }) {
      commit('setConnectionProblem', true)
    },
    async pingConnection({ commit }) {
      await bizmatesApi.ping()
        .then(() => {
          commit('setInternetFailCount', 0);
        })
        .catch(function () {
          commit('setInternetFailCount', 1);
        });
    }
  }
};
